/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface DisableUserUsageLimit200ResponseReissueOneOf
 */
export interface DisableUserUsageLimit200ResponseReissueOneOf {
    /**
     * 
     * @type {string}
     * @memberof DisableUserUsageLimit200ResponseReissueOneOf
     */
    'cardType': DisableUserUsageLimit200ResponseReissueOneOfCardTypeEnum;
    /**
     * Expiration date of the previous virtual card that was replaced by automatic reissuance.
     * @type {string}
     * @memberof DisableUserUsageLimit200ResponseReissueOneOf
     */
    'expiredDate': string;
}

export const DisableUserUsageLimit200ResponseReissueOneOfCardTypeEnum = {
    virtual: 'virtual'
} as const;

export type DisableUserUsageLimit200ResponseReissueOneOfCardTypeEnum = typeof DisableUserUsageLimit200ResponseReissueOneOfCardTypeEnum[keyof typeof DisableUserUsageLimit200ResponseReissueOneOfCardTypeEnum];


